import { Close } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  Collapse,
  IconButton,
  Skeleton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { CompanyStatus, NewOrderTypes } from '../../../../common/enums/enums';
import { useGetVendorsQuery } from '../../../../redux/rtk/vendors.services';
import { currentUserCompanyId } from '../../../../redux/selectors/userDataSelectors';
import { getSelectorActionsBasedOnType } from '../helper';
import ListVendor from './components/ListVendors';

export default function Vendor({
  onValidStep,
  onToggle,
  boxProps = { p: { xs: 2, md: 6 } },
  orderType = NewOrderTypes.SIMPLE_ORDER,
}) {
  const dispatch = useDispatch();
  const userCompany = useSelector(currentUserCompanyId);
  const { data: vendors, isLoading } = useGetVendorsQuery(userCompany);
  const activeVendors = vendors?.filter(
    vendor => vendor?.companyStatus !== CompanyStatus.INACTIVE
  );
  const {
    setSelectedVendorAction,
    selectedVendorSelector,
    setAllDealersAction,
  } = getSelectorActionsBasedOnType(orderType);

  const selectedVendor = useSelector(selectedVendorSelector);
  const [showAlertToggle, setShowAlertToggle] = useState(!!onToggle);
  const { t } = useTranslation('orders');
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(
    () =>
      onValidStep(
        !!selectedVendor?.companyId && selectedVendor?.active !== false
      ),
    [onValidStep, selectedVendor]
  );

  useEffect(() => {
    if (selectedVendor?.companyId) {
      dispatch(setAllDealersAction(selectedVendor?.companyId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedVendor]);

  return (
    <>
      <Collapse in={showAlertToggle}>
        <Alert
          severity="info"
          action={
            <>
              <Button size="small" onClick={onToggle}>
                {(smallScreen && t('newOrder.swithModeSmall')) ||
                  t('newOrder.swithModeSinglePageLarge')}
              </Button>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => setShowAlertToggle(false)}
              >
                <Close fontSize="small" />
              </IconButton>
            </>
          }
        >
          {t('newOrder.singlePageMessage')}
        </Alert>
      </Collapse>
      <Box {...boxProps}>
        <Box>
          <Typography variant="h6" mb={5}>
            {t('newOrder.vendor.title')}
          </Typography>
        </Box>
        <Typography fontSize="small" mb={2}>
          {t('newOrder.vendor.selectVendor')}:
        </Typography>
        {isLoading ? (
          <Box>
            {[...new Array(5)].map((item, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                width={'100%'}
                height={64}
                sx={{ marginBottom: '8px' }}
                data-testid="skeleton"
              />
            ))}
          </Box>
        ) : (
          <Box>
            <ListVendor
              vendors={activeVendors}
              selectedVendor={selectedVendor}
              onSelectedVendor={vendor => {
                dispatch(setSelectedVendorAction(vendor));
              }}
            ></ListVendor>
          </Box>
        )}
      </Box>
    </>
  );
}
